<template>
  <div class=" uk-margin-remove-top" style="background-image: url('/statement.jpg'); background-size: cover; ">
    <div class="uk-padding-large" style="background-color: rgba(0, 0, 0, 0.7); ">
      <div class="uk-container" >

        <div class=" uk-child-width-1-3@m " uk-grid>
          <div>
            <div>
              <div class="uk-card uk-card-default uk-card-small uk-card-body uk-text-left" style="background: transparent">
                <h3 class="uk-card-title">Mission Statement</h3>
                <p class="uk-light">
                  The mission of Northern Caribbean University, a Seventh-day Adventist institution,
                  is to improve the human condition by providing Christ-centered education through
                  academic excellence, values-based focus, spiritual and physical development, social
                  interaction, and a strong work ethic thereby equipping each student for committed professional
                  service to all people, and to God.
                </p>
              </div>
            </div>
          </div>

          <div>
            <div>
              <div class="uk-card uk-card-default uk-card-small uk-card-body uk-text-left" style="background: transparent">
                <h3 class="uk-card-title">Vision Statement</h3>
                <p class="uk-light">
                  Northern Caribbean University will be the premier institution of higher learning in
                  the Northern Caribbean region with a commitment to offering innovative, quality,
                  accessible Christ- centered education.
                </p>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div class="uk-card uk-card-default uk-card-small uk-card-body uk-text-left" style="background: transparent">
                <h3 class="uk-card-title">Core Values</h3>
                <ul class="uk-light">
                  <li>ACCOUNTABILITY</li>
                  <li>FAIRNESS</li>
                  <li>FORGIVENESS</li>
                  <li>INTEGRITY</li>
                  <li>RESPECT</li>
                  <li>MERCY</li>
                  <li>SERVICE EXCELLENCE</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "statements"
}
</script>

<style scoped>

h3{
  color:  gold !important;
}
@media screen and (max-width:600px){


  h3{
    font-size: 1.1em !important;
  }
  h1{
    font-size: 1.2em !important;
  }
  p{
    font-size: 0.7em !important;
  }
  a{
    font-size: 0.9em !important;
  }


}
</style>
